import React from 'react';
import SuccessFactorsContent from '../components/SuccessFactorsContent/SuccessFactorsContent';

const SapSuccessFactorsPage = () => {
  return (
    <>
      <SuccessFactorsContent />
    </>
  );
};

export default SapSuccessFactorsPage;
